(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lood-snelbestellen"] && !Shopify.designMode) return;
  try {
    
function initLoodOrders(root=document){root.querySelectorAll('[data-lood-order]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const form=section.querySelector('[data-lood-form]'),status=section.querySelector('[data-lood-status]'),button=section.querySelector('[data-lood-submit]'),rows=[...section.querySelectorAll('[data-lood-row]')];const count=section.querySelector('[data-lood-count]');form.addEventListener('input',()=>{const n=[...form.querySelectorAll('[data-variant-id]:not(:disabled)')].reduce((total,input)=>total+Math.max(0,Number(input.value)||0),0);count.textContent=n+' ×';});section.querySelector('[data-lood-filter]').addEventListener('input',event=>{const words=event.target.value.toLocaleLowerCase().trim().split(/\s+/);let visible=0;rows.forEach(row=>{row.hidden=!words.every(word=>row.dataset.title.toLocaleLowerCase().includes(word));if(!row.hidden)visible++});section.querySelector('[data-lood-no-results]').hidden=visible>0});form.addEventListener('submit',async event=>{event.preventDefault();if(!form.reportValidity())return;const items=[...form.querySelectorAll('[data-variant-id]:not(:disabled)')].filter(input=>Number(input.value)>0).map(input=>({id:input.dataset.variantId,quantity:Number(input.value)}));if(!items.length){status.textContent=status.dataset.empty;return}button.disabled=true;status.textContent=status.dataset.loading;try{const response=await fetch(section.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||status.dataset.error);window.location.assign(section.dataset.cartUrl)}catch(error){status.textContent=error.message||status.dataset.error;button.disabled=false}})})}initLoodOrders();document.addEventListener('shopify:section:load',event=>initLoodOrders(event.target));

  } catch(e) { console.error(e); }
})();
})();
